import axios from 'axios';

import { config } from 'config';

export const sendEmail = async (
  email: string,
  phone: string,
  content: string,
): Promise<any> => {
  const url = `${config.backendUrl}/sendMail`;
  const response = await axios.post<any>(url, {
    email,
    phone,
    content,
  });
  return response.data;
};
